import { useCallback } from 'react';
import useFileManagerStore from 'src/stores/fileManagerStore';

interface UseDeferredFileUsageProps {
  contentType: string;
  contentId: string;
  fieldName: string;
}

const useDeferredFileUsage = ({ contentType, contentId, fieldName }: UseDeferredFileUsageProps) => {
  const {
    addPendingFile: storeAddPendingFile,
    markPendingFilesAsUsed: storeMarkPendingFilesAsUsed,
    clearPendingFiles: storeClearPendingFiles,
    removePendingFile: storeRemovePendingFile,
    pendingFiles
  } = useFileManagerStore();

  const addPendingFile = useCallback((fileId: string) => {
    console.log('Adding pending file:', fileId, 'for', contentType, contentId, fieldName);
    storeAddPendingFile(fileId, contentType, contentId, fieldName);
  }, [storeAddPendingFile, contentType, contentId, fieldName]);

  const markPendingFilesAsUsed = useCallback(async () => {
    console.log('Marking pending files as used for', contentType, contentId, fieldName);
    await storeMarkPendingFilesAsUsed(contentType, contentId, fieldName);
  }, [storeMarkPendingFilesAsUsed, contentType, contentId, fieldName]);

  const clearPendingFiles = useCallback(() => {
    console.log('Clearing pending files for', contentType, contentId, fieldName);
    storeClearPendingFiles(contentType, contentId, fieldName);
  }, [storeClearPendingFiles, contentType, contentId, fieldName]);

  const removePendingFile = useCallback((fileId: string) => {
    console.log('Removing pending file:', fileId, 'for', contentType, contentId, fieldName);
    storeRemovePendingFile(fileId, contentType, contentId, fieldName);
  }, [storeRemovePendingFile, contentType, contentId, fieldName]);

  // Get pending files for this specific content
  const key = `${contentType}:${contentId}:${fieldName}`;
  const currentPendingFiles = pendingFiles.get(key) || [];

  return {
    addPendingFile,
    markPendingFilesAsUsed,
    clearPendingFiles,
    removePendingFile,
    pendingFiles: currentPendingFiles
  };
};

export default useDeferredFileUsage;
